<div class="flex items-center gap-x-2">

    <app-button
        [label]="venueLayout.venueConfigs.buttonLabel() || translation.getText('venue_layout', 'venue_layout_button', 'Layouts')"
        [disabled]="venueLayout.isAnimating()"
        [active]="venueLayout.showContainer()"
        [custom]="['dark-button', 'max-w-[11.5rem]', '[&>span]:block', '[&>span]:truncate']"
        (event)="venueLayout.toggleContainer()"
    />

</div>
